import { render, staticRenderFns } from "./ProlongateDlg.vue?vue&type=template&id=357665ec&"
import script from "./ProlongateDlg.vue?vue&type=script&lang=js&"
export * from "./ProlongateDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports